import { ResourceFile } from './Shared/DomainValidationFunctions';

export const abnMustBeValid = 'Please enter a valid ABN';
export const emailAddressMustBeValid = 'Please enter a valid email address';
export const timeZoneIsRequired = 'Please select a time zone';
export const noRecordsFound = 'Whoops! We could not find any records.';
export const requiredField = 'Required';
export const invalidField = 'Invalid';
export const minimumOneItem = 'Must have at least 1 item.';
export const sexIsRequired = 'Please enter a sex.';
export const familyNameIsRequired = 'Please enter a family name.';
export const givenNameIsRequired = 'Please enter a given name.';
export const invalidDate = 'Invalid date';
export const invalidYear = 'Year is invalid';
export const dateIsInTheFuture = 'Date is in the future';
export const yearIsInTheFuture = 'Year is in the future';
export const beforeStartDate = 'Before Start date';
export const afterExpiryDate = 'After Expiry date';
export const afterTodayDate = 'Date must be after today';
export const oneMedicationMustBeSelected = 'One medication must be chosen';
export const requestMustExpireBeforeMeds = 'Invalid expiry';

export const MedicationLocale: ResourceFile = {
    PatientMedication_BeforeStartDate: beforeStartDate,
    PatientMedication_AfterExpiryDate: afterExpiryDate,
    PharmacyRequest_ExpiryDateRequired: requiredField,
    PharmacyRequest_ExpiryDateIsLessThanToday: afterTodayDate,
    PharmacyRequest_ExpiryIsGreaterThanMedicationMax: requestMustExpireBeforeMeds
};
